"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var matchOffersWithItems = function (items, offers) {
    var usedItemIds = [];
    var usedOfferIds = [];
    var matches = [];
    var match = false;
    do {
        match = false;
        // It's complaining we shouldnt use loops
        // eslint-disable-next-line
        offers
            .filter(function (o) { return !usedOfferIds.includes(o.id); })
            .forEach(function (offer) {
            if (match) {
                // Loop from start if we have already matched
                return;
            }
            var availableItems = items.filter(function (item) { return !usedItemIds.includes(item.id); });
            if (availableItems.length === 0) {
                return;
            }
            if (offer.type === 'BUNDLE' && offer.items.length > 0) {
                var matchedItems = offer.items.map(function (oItem) { return availableItems.find(function (aItem) { return aItem.itemId === oItem.id; }); });
                var hasCompleteMatch = matchedItems.every(Boolean);
                if (hasCompleteMatch) {
                    var ids = matchedItems.map(function (i) { return i.id; });
                    usedItemIds = usedItemIds.concat(ids);
                    usedOfferIds.push(offer.id);
                    matches.push({
                        offerId: offer.id,
                        offerName: offer.title,
                        items: matchedItems,
                    });
                    match = true;
                }
            }
            if (offer.stages.length > 0) {
                var matchedItems_1 = [];
                offer.stages.forEach(function (stage) {
                    var item = _.intersectionWith(availableItems, stage.items, function (aItem, sItem) { return aItem.itemId === sItem.id; })[0];
                    if (item) {
                        matchedItems_1.push(item);
                    }
                });
                if (matchedItems_1.length === offer.stages.length) {
                    var matchedIds = matchedItems_1.map(function (i) { return i.id; });
                    usedItemIds = usedItemIds.concat(matchedIds);
                    usedOfferIds.push(offer.id);
                    matches.push({
                        offerId: offer.id,
                        offerName: offer.title,
                        items: matchedItems_1,
                    });
                    match = true;
                }
            }
        });
    } while (match);
    return {
        matches: matches,
        unmatched: items.filter(function (i) { return !usedItemIds.includes(i.id); }),
    };
};
exports.default = matchOffersWithItems;
